import type { Region } from "@/types/geodata";

export function RegionHeader({ region }: { region: Region }) {
  return (
    <header className="rounded-md border bg-card p-4">
      <p className="text-xs uppercase text-muted-foreground">{region.country}</p>
      <div className="mt-1 flex items-start justify-between gap-4">
        <h2 className="text-2xl font-semibold">{region.name}</h2>
        <span className="rounded-sm bg-red-500/20 px-2 py-1 text-sm text-red-100">
          {region.pressureIndex}
        </span>
      </div>
      <p className="mt-3 text-sm text-muted-foreground">{region.summary}</p>
    </header>
  );
}
